module.exports = __webpack_public_path__ + "71433c74dfd700400d83e28db5535ca0.svg";